




















































import { Component, Mixins, Prop } from "vue-property-decorator";
import NavigationBarLink from "./NavigationBarLink.vue";
import LocaleChanger from "./LocaleChanger.vue";
import CurrencyChanger from "./CurrencyChanger.vue";
import onScrollAnimationMixin from "@/mixins/onScrollAnimationMixin";
import { RouteConfig } from "vue-router";
import { commonRoutes } from "@/router";
import { capitalize } from "lodash";

@Component({
  components: {
    NavigationBarLink,
    LocaleChanger,
    CurrencyChanger,
  },
})
export default class NavigationBar extends Mixins(onScrollAnimationMixin) {
  @Prop({ default: false }) readonly fixed?: boolean;

  private scrolled: boolean = false;

  get version(): string {
    return process.env.VUE_APP_VERSION as string; //(process.env.NODE_ENV === 'production') ? '' : process.env.VUE_APP_VERSION as string;
  }

  get name(): string {
    return this.$storage.getters.getPlatformInfo().name;
  }

  get loading(): boolean {
    return this.$store.state.loading;
  }

  get links(): Array<RouteConfig> {
    return commonRoutes;
  }

  protected animate(): void {
    this.scrolled = this.isPageScrolled();
  }

  protected mount() {
    this.animate();
  }
  private goToStore() {
    window.open("https://bonifique.store", "_blank");
  }
}
